export const INIT_CASTELLETTO = 'INIT_CASTELLETTO';

export const GET_DATI_CASTELLETTO_PERIODO_SUCCESS = 'GET_DATI_CASTELLETTO_PERIODO_SUCCESS';
export const GET_DATI_CASTELLETTO_PERIODO_FAIL = 'GET_DATI_CASTELLETTO_PERIODO_FAIL';

export const SET_LOADING = 'SET_LOADING';

export const GET_DATI_CASTELLETTO_PERIODO_TOTALE_SUCCESS = 'GET_DATI_CASTELLETTO_PERIODO_TOTALE_SUCCESS';
export const GET_DATI_CASTELLETTO_PERIODO_TOTALE_FAIL = 'GET_DATI_CASTELLETTO_PERIODO_TOTALE_FAIL';
